import { render, staticRenderFns } from "./multi-page.vue?vue&type=template&id=4eb3b9a4&scoped=true&"
import script from "./multi-page.vue?vue&type=script&lang=js&"
export * from "./multi-page.vue?vue&type=script&lang=js&"
import style0 from "./multi-page.vue?vue&type=style&index=0&id=4eb3b9a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb3b9a4",
  null
  
)

export default component.exports